import React from "react";
import { IconButton } from "../components/IconButton";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLScreen from "./VLScreen";

class GroupsScreen extends VLScreen {

    constructor() {
        super();
        this.state = { loaded: false, groups: [], hideBack: true, showMenu: true, floodCount: [] };
    }

    componentDidMount() {
        API.POST("groups/list", {}, result => {
            Util.handleLogout(result);
            if (result.success) {
                this.setState(result.result);
                let floods = result.result.floods;
                let floodCount = [floods.filter(e => e.severity == 3).length, floods.filter(e => e.severity == 2).length, floods.filter(e => e.severity == 1).length];
                this.setState({ floodCount });
                setTimeout(() => {
                    this.setState({ loaded: true });
                }, 500);
            }
        });
    }

    content() {
        return (
            <div id="content" style={{
                justifyContent: "center",
                width: "100%",
                display: "flex",
                height: "auto"
            }}>

                <div style={{
                    width: "25cm",
                    maxWidth: "90vw",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    display: this.state.loaded ? "flex" : "none",
                    margin: "0 auto",
                    height: "auto"
                }}>
                    <div><img src={this.state.app_image} style={{ width: "30vw", marginTop: 30 }} /></div>
                    <br />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                        className="wide"
                    >
                        {/* Left Half */}
                        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                            <div>
                                {this.renderFloods()}
                            </div>
                        </div>
                        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                            {this.renderInfo()}
                        </div>
                    </div>

                    {this.renderGroups()}
                    <br /> <br />

                </div>
            </div>

        );
    }

    title = () => {
        return this.state.app_name;
    };

    renderInfo = () => {
    let online = this.state.sensors - this.state.sensors_offline;
    return (
        <div>
            <p className="text">{online}/{this.state.sensors} of your registered systems are online</p>
            <p className="text">{this.state.ea_online} Environment Agency stations online</p>
            <p className="text">{this.state.nrw_online} Natural Resources Wales stations online</p>
        </div>
    );
};


    renderGroups = () => {
        let groups = this.state.groups.filter(g => g != null && g.name != "null" && g.name != null && g.name != "");
        let rows = groups.map((g, i) => {
            return (
                <div style={{ flex: 1, padding: 16 }}>
                    <div style={{
                        textAlign: "center",
                        padding: 16,
                        borderColor: window.primary,
                        borderWidth: 2,
                        borderStyle: "solid",
                        borderRadius: 16
                    }}>
                        <h2>{g.name}</h2>
                        <h5>{g.systems} systems</h5>
                        {this.renderButton("List", "/list/" + i, "list")}
                        {this.renderButton("Matrix", "/matrix/" + i, "photo_library")}
                        {this.renderButton("Map", "/map", "map")}
                    </div>
                </div>
            );
        });
        return <div
            style={{ display: "flex", width: "calc(32px + 100%)", marginLeft: -16, marginRight: -16 }}>{rows}</div>;
    };

    renderFloods = () => {
        return <div style={{ display: "flex", width: 370, justifyContent: "space-between", marginTop: 8 }}>
            {this.state.floodCount.map((f, i) => this.floodAlert("flood" + (i + 1), f, 3 - i))}
        </div>;
    };

    floodAlert = (icon, alerts, id) => {
        const name = ["", "Severe", "Warnings", "Alerts"][id];
        const hasAlerts = !(alerts == 0 || alerts == null);
        const clicked = hasAlerts ? (() => this.props.navigate("/floods/" + id)) : null;
        return <div className="hoverable" style={{ textAlign: "center" }} onClick={clicked}>
            <img style={{ width: 90, height: 80 }} src={require("../icons/" + icon + ".png")} />
            <p>{hasAlerts ? alerts : "No"} {name}</p>
        </div>;
    };

    renderFaults = () => {
        const unassigned = this.state.unassignedFaults;
        return (
            <div style={{
                textAlign: "center",
                padding: 16,
                borderColor: unassigned ? "red" : window.primary,
                borderWidth: 2,
                borderStyle: "solid",
                borderRadius: 16,
                color: unassigned ? "red" : "black",
                margin: 16
            }}>
                {unassigned == 0 ? <h3>No New Faults</h3> : <h3>{unassigned} NEW FAULTS REQUIRE ATTENTION</h3>}
                {this.renderButton(unassigned == 0 ? "View System Performance" : "View Now", "/faults/1")}
            </div>
        );
    };

    renderButton = (title, link, icon) => {
        if (icon == null) {
            return <VLButton className="wide top8" href={link} title={title} />;
        } else {
            return <IconButton icon={icon} className="wide top8" href={link} title={title} />;
        }

    };

}

export default GroupsScreen;